type PriceTableRoomPrice = {
  price?: number | null;
};

type PriceTablePackageData = {
  defaultPackageDetail?: {
    roomPrices?: {
      prices?: PriceTableRoomPrice[] | null;
      childPrices?: PriceTableRoomPrice[] | null;
    } | null;
  };
};

const hasSellablePrice = (price?: number | null): boolean =>
  price != null && price > 0;

export const hasPriceTableData = (
  packageData?: PriceTablePackageData | null
): boolean => {
  const roomPrices = packageData?.defaultPackageDetail?.roomPrices;
  const prices = (roomPrices?.prices || []).some((item) =>
    hasSellablePrice(item.price)
  );
  const childPrices = (roomPrices?.childPrices || []).some((item) =>
    hasSellablePrice(item.price)
  );

  return prices || childPrices;
};
